<template>
  <div class="col-md-6 col-lg-3">
    <div class="card h-100 border-0 shadow-sm" :style="bgColor ? { backgroundColor: bgColor } : null">
      <div :class="['card-body', 'd-flex', 'flex-column', compact ? '' : 'justify-content-between', bgColor ? 'text-white' : '']">
        <div :class="['d-flex justify-content-between align-items-center', compact ? '' : 'mb-2']">
          <div>
            <slot name="value">
              <span class="fs-4 fw-bold text-teal">{{ value }}</span>
            </slot>
          </div>
          <span v-if="badge" :class="badgeClass">{{ badge }}</span>
        </div>
        <div :class="['small', bgColor ? '' : 'text-muted']">
          <p class="mb-0">{{ title }}</p>
          <small :class="bgColor ? 'text-white-50' : 'text-secondary'">{{ subtitle }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KPICard',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    value: { type: String, default: '' },
    badge: { type: String, default: '' },
    compact: { type: Boolean, default: false },
    badgeVariant: { type: String, default: 'teal' },
    bgColor: { type: String, default: '' }
  },
  computed: {
    badgeClass() {
      if (this.bgColor) {
        return 'badge bg-white text-body rounded-pill fs-6'
      }
      return this.badgeVariant === 'teal'
        ? 'badge bg-teal rounded-pill fs-6'
        : 'badge bg-light text-secondary border rounded-pill fs-6'
    }
  }
}
</script>
